import { DialogContent as StyledDialogContent } from './DialogContent.styled';
import { Props } from './types';

export const DialogContent = ({ ...props }: Props) => <StyledDialogContent {...props} />;

export default DialogContent;
